import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { Sparkles, AlertTriangle, ArrowRight } from 'lucide-react';
import { subscriptionApi } from '@/features/subscription/api/subscriptionApi';
import { Button } from '@/ui/Button';

export function TrialBanner() {
  const { data: overview, isLoading } = useQuery({
    queryKey: ['admin', 'subscription'],
    queryFn: subscriptionApi.getOverview,
    staleTime: 60_000,
  });

  if (isLoading || !overview?.subscription) return null;

  const sub = overview.subscription;
  const isTrial = sub.status === 'TRIAL';
  const isExpired = sub.status === 'EXPIRED';

  if (!isTrial && !isExpired) return null;

  if (isExpired) {
    return (
      <div className="bg-danger/10 border-b border-danger/30 px-4 py-2.5 text-danger text-sm flex items-center justify-between flex-wrap gap-2">
        <div className="flex items-center gap-2">
          <AlertTriangle className="h-4 w-4 shrink-0 text-danger" />
          <span>
            <strong>Your store subscription has expired.</strong> Storefront visitors cannot place orders until renewed.
          </span>
        </div>
        <Link to="/admin/subscription">
          <Button size="sm" variant="danger">
            Pay & Reactivate
          </Button>
        </Link>
      </div>
    );
  }

  return (
    <div className="bg-mustard-100 border-b border-mustard-300 px-4 py-2 text-content text-xs sm:text-sm flex items-center justify-between flex-wrap gap-2">
      <div className="flex items-center gap-2">
        <Sparkles className="h-4 w-4 text-mustard-700 shrink-0" />
        <span>
          <strong>1-Month Free Trial:</strong> You have <strong>{sub.days_remaining} day{sub.days_remaining === 1 ? '' : 's'} remaining</strong>.
        </span>
      </div>
      <Link to="/admin/subscription" className="inline-flex items-center gap-1 font-semibold text-mustard-700 hover:underline">
        Upgrade plan <ArrowRight className="h-3.5 w-3.5" />
      </Link>
    </div>
  );
}

